export const INITIAL_POSITIONS_PER_PAGE = 3; // Number of items to load on the first call
export const FETCH_MORE_POSITIONS_PER_PAGE = 10; // Number of items to load on subsequent calls
